import { useTranslation } from "react-i18next";
import { useErrorDialog } from ".";
import { jwtDecode, JwtPayload } from "jwt-decode";
import {
  CognitoIdentityProviderClient,
  InitiateAuthCommand,
  InitiateAuthCommandInput,
} from "@aws-sdk/client-cognito-identity-provider";

const client = new CognitoIdentityProviderClient({ region: "ap-northeast-1" });

export type onOkState =
  //OKボタンを押下後、
  // 1)タブが閉じるか
  // 2)トップページに遷移するか
  // 3)ログイン画面に遷移するか
  // 4)何も起こらないか(ただエラーダイアログが閉じられる)
  "closeTab" | "navigateToTopPage" | "login" | "";

export const useSession = (
  onOk: onOkState = "login" //デフォルト値=ログイン画面に遷移する
) => {
  //言語切替用
  const { t } = useTranslation();
  // エラーダイアログ表示
  const { showErrorDialog } = useErrorDialog();
  const userpool_client_id =
    process.env.REACT_APP_AWS_USER_POOLS_WEB_CLIENT_ID ?? "";

  // セッション情報チェック
  const handleCheckSession = async () => {
    try {
      let isNeedUpdateToken = false;
      // セッション情報取得
      const encIdToken =
        localStorage.getItem(
          `CognitoIdentityServiceProvider.${process.env.REACT_APP_AWS_USER_POOLS_WEB_CLIENT_ID}.idToken`
        ) || "";
      const idToken = jwtDecode<JwtPayload>(encIdToken);
      const refreshToken =
        localStorage.getItem(
          `CognitoIdentityServiceProvider.${process.env.REACT_APP_AWS_USER_POOLS_WEB_CLIENT_ID}.refreshToken`
        ) || "";
      if (idToken) {
        const exp = idToken.exp;
        if (!exp) {
          //idTokenの期限が設定されてない
          console.log("token exp is not configured");
          isNeedUpdateToken = true;
        } else if (exp < Date.now() / 1000) {
          //idTokenの期限切れ
          console.log("token is expired");
          isNeedUpdateToken = true;
        }
      } else {
        //idTokenが存在しない
        console.log("token is not configured");
        isNeedUpdateToken = true;
      }

      if (isNeedUpdateToken) {
        const params = {
          AuthFlow: "REFRESH_TOKEN_AUTH",
          ClientId: userpool_client_id,
          AuthParameters: {
            REFRESH_TOKEN: refreshToken,
          },
        } as InitiateAuthCommandInput;
        const command = new InitiateAuthCommand(params);
        const response = await client.send(command);
        const newIdToken = response.AuthenticationResult?.IdToken;
        const newAccessToken = response.AuthenticationResult?.AccessToken;

        if (newIdToken && newAccessToken) {
          //新しいトークンを保存
          //accessToken
          localStorage.setItem(
            `CognitoIdentityServiceProvider.${userpool_client_id}.accessToken`,
            newAccessToken
          );

          //id_token
          localStorage.setItem(
            `CognitoIdentityServiceProvider.${userpool_client_id}.idToken`,
            newIdToken
          );
        } else {
          // トークン更新が不可能ならログイン画面へ

          //エラー", セッションがタイムアウトしました,(トップ画面にリダイレクト)
          showErrorDialog(
            t("共通エラーポップ.エラー"),
            t("共通エラーポップ.セッションがタイムアウトしました。"),
            onOk
          );
        }
      }
    } catch (err) {
      console.log("[handleCheckSession]err: ", err);
      showErrorDialog(
        t("共通エラーポップ.エラー"),
        t("共通エラーポップ.通信エラーが発生しました。")
      ); //エラー", "通信エラーが発生しました。
    }
  };

  return { handleCheckSession };
};
